import { ReactNode } from 'react'

import { Subtitle } from '@joor/design-system'

import styles from './SettingsSection.module.css'

interface SettingsSectionProps {
  title: string
  children: ReactNode
  className?: string
}

export const SettingsSection = ({
  title,
  children,
  className,
}: SettingsSectionProps) => {
  return (
    <div className={`${styles.section} ${className ?? ''}`}>
      <Subtitle type="1">{title}</Subtitle>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
